export function Bone({ className }: { className?: string }) {
  return <div aria-hidden="true" className={`bone rounded-md${className ? ` ${className}` : ''}`} />
}
